import { useTranslation } from 'react-i18next';
import { Card, CardHeader, CardTitle } from '@monigo/ui';
import { env } from '../../lib/env.js';

export function SupportPage() {
  const { t } = useTranslation();
  return (
    <Card>
      <CardHeader>
        <CardTitle>{t('support.title')}</CardTitle>
      </CardHeader>
      <p className="text-sm">
        <a className="text-primary hover:underline" href={`mailto:${env.supportEmail}`}>
          {t('support.email', { email: env.supportEmail })}
        </a>
      </p>
    </Card>
  );
}
